import AddScopeFilters from './AddScopeFilters';

export default AddScopeFilters;
